export default "__VITE_ASSET__CYbcIy3h__"